import {
    Box, Heading, Image, Text
} from "@chakra-ui/react";
const Sponsor = (props) => {
    return (
        <Box mt="30px" mb="100px" fontSize="14px" fontWeight="500">
            <Heading my="30px" fontSize="26px" fontWeight="600">
                Meet the Sponsor
            </Heading>
            {!props.data || props.data?.length == 0 ?
                <Text w="100%" textAlign="center" my="50px">No items to Display</Text>
                :
                props.data?.map((sponsor, index) => {
                    return (
                        <Box key={index}>
                            <Box mb="30px">
                                <Image src={sponsor.image} alt="sponsor" />
                            </Box>
                            <Box mb="30px">
                                <Text>{sponsor.description}</Text>
                            </Box>
                        </Box>

                    );
                }
                )}
        </Box>
    );
}

export default Sponsor;